// Cầu nối: chuyển các thẻ "tương thích" sang ContentItem để tái dùng ContentRenderer.
// Các thẻ KHÔNG có block tương ứng (html, pdf, pptx, simulation, word) được render
// bằng component Preview chuyên dụng trong feature module (xem LessonCardRenderer).
import type { ContentItem } from '../../../types'
import type { Card } from '../types/LessonDoc'

/**
 * Trả về ContentItem[] nếu thẻ map được sang block sẵn có của ContentRenderer,
 * ngược lại trả null (renderer chuyên dụng sẽ xử lý).
 */
export function cardToContentItems(card: Card): ContentItem[] | null {
  switch (card.type) {
    case 'text':
      return [{ type: 'text', content: card.content }]

    case 'rich':
      return card.items || []

    case 'infographic':
      return [
        {
          type: 'image',
          content: card.imageSrc,
          caption: card.caption,
          alt: card.title || card.caption || 'infographic',
        },
      ]

    case 'video':
      if (card.youtubeId) {
        return [
          {
            type: 'video',
            content: card.youtubeId,
            title: card.title,
            caption: card.caption,
          },
        ]
      }
      return [
        {
          type: 'video',
          content: card.src || '',
          title: card.title,
          caption: card.caption,
        },
      ]

    case 'quiz':
      return [
        {
          type: 'quiz',
          content: '',
          title: card.title,
          questions: card.questions,
          timeLimit: card.timeLimit,
          passingScore: card.passingScore,
        },
      ]

    default:
      return null
  }
}
